import React, { useState, useRef } from 'react';
import { IconButton } from '@mui/material';
import { VolumeUpRounded, VolumeDownRounded } from '@mui/icons-material';
import { Slider } from 'src/shared/ui/slider';
import { preventPropagation } from '../../utils/event-utils';

interface VolumeControlProps {
  volume: number;
  onVolumeChange: (volume: number) => void;
  toggleMute: () => void;
}

export const VolumeControl: React.FC<VolumeControlProps> = ({
  volume,
  onVolumeChange,
  toggleMute,
}) => {
  const [isVolumeSliderVisible, setIsVolumeSliderVisible] = useState(false);
  const hideVolumeSliderTimeout = useRef<NodeJS.Timeout | null>(null);

  const showVolumeSlider = () => {
    if (hideVolumeSliderTimeout.current) {
      clearTimeout(hideVolumeSliderTimeout.current);
      hideVolumeSliderTimeout.current = null;
    }
    setIsVolumeSliderVisible(true);
  };

  const hideVolumeSlider = () => {
    hideVolumeSliderTimeout.current = setTimeout(() => {
      setIsVolumeSliderVisible(false);
    }, 300);
  };

  return (
    <div className="relative" onMouseEnter={showVolumeSlider} onMouseLeave={hideVolumeSlider}>
      <IconButton onClick={toggleMute} className="text-white hover:text-primary">
        {volume > 0 ? <VolumeUpRounded /> : <VolumeDownRounded />}
      </IconButton>

      {isVolumeSliderVisible && (
        <div className="absolute right-0 z-30 transform -translate-x-12 translate-y-8 bottom-full">
          <div className="py-2">
            <Slider
              min={0}
              max={1}
              step={0.05}
              value={[volume]}
              onValueChange={(value) => onVolumeChange(value[0])}
              className="w-24 h-2"
              onClick={preventPropagation}
            />
          </div>
        </div>
      )}
    </div>
  );
};
